<div mat-dialog-title class="ds">
  <span>{{appStrings.followUp_editLead_title}}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="content ds" [ngClass]="{'mobile': isMobile}">
  @if (loading) {
    <div class="loading" id="loading">
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }
  @if (!loading) {
    <div class="edit-lead-container">
      <form [formGroup]="editLeadForm">
        <div class="container">
          <div class="title">
            <typography variant="mat-body-2" weight="medium">
              {{ appStrings.accounts_labelBusiness }}
            </typography>
          </div>
          <div class="content" formGroupName="business" id="business">
            <ds-autocomplete [ngClass]="isMobile ? 'fill-width' : 'quarter-width'" [options]="accountManagers" [label]="appStrings.followUp_leads_leadOwner"
              label_orientation="vertical-label" [control]="editLeadForm.controls.business.controls.leadOwnerId" id="leadOwner"
            ></ds-autocomplete>
            <ds-textfield class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.followUp_editLead_companyName" label_orientation="vertical-label"
              [control]="editLeadForm.controls.business.controls.companyName" id="companyName"
            ></ds-textfield>
            <ds-select [ngClass]="isMobile ? 'fill-width' : 'quarter-width'" [label]="appStrings.followUp_leads_source" [dropOptions]="sources"
              label_orientation="vertical-label" [control]="editLeadForm.controls.business.controls.sourceTypeId" id="source"
            ></ds-select>
            <ds-textfield class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.contacts_addressLine1" label_orientation="vertical-label"
              [control]="editLeadForm.controls.business.controls.address1" id="address1"
            ></ds-textfield>
            <ds-textfield class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.contacts_addressLine2" label_orientation="vertical-label"
              [control]="editLeadForm.controls.business.controls.address2" id="address2"
            ></ds-textfield>
            <ds-select (selectionChange)="handleCountryChange()" class="quarter-width" [label]="appStrings.contacts_country" [dropOptions]="countries"
              label_orientation="vertical-label" [control]="editLeadForm.controls.business.controls.countryId" id="country"
            ></ds-select>
            @if (isSelectBusinessState && !isHiddenBusinessState) {
              <ds-select class="quarter-width" [label]="appStrings.contacts_state_province"
                [dropOptions]="businessStates" label_orientation="vertical-label" [control]="editLeadForm.controls.business.controls.stateId" id="state"
              ></ds-select>
            }
            @if (isRegionCountyBusiness && !isHiddenBusinessState) {
              <ds-select (selectionChange)="handleRegionChange()" class="quarter-width"
                [label]="appStrings.contacts_region" [dropOptions]="businessRegions" label_orientation="vertical-label"
                [control]="editLeadForm.controls.business.controls.regionId" id="region"
              ></ds-select>
            }
            @if (isRegionCountyBusiness && !isHiddenBusinessState) {
              <ds-select class="quarter-width" [label]="appStrings.contacts_county"
                [dropOptions]="businessCounties" label_orientation="vertical-label" [control]="editLeadForm.controls.business.controls.countyId" id="county"
              ></ds-select>
            }
            @if (!isSelectBusinessState && !isHiddenBusinessState && !isRegionCountyBusiness) {
              <ds-textfield class="quarter-width" id="province"
                [label]="appStrings.contacts_state_province" label_orientation="vertical-label" [control]="editLeadForm.controls.business.controls.province.controls.name"
              ></ds-textfield>
            }
            <ds-textfield class="quarter-width" [label]="appStrings.followUp_editLead_city" label_orientation="vertical-label"
              [control]="editLeadForm.controls.business.controls.city" id="city"
            ></ds-textfield>
            <ds-textfield class="quarter-width" [label]="zipLabel" label_orientation="vertical-label"
              [control]="editLeadForm.controls.business.controls.zipCode" id="zip"
            ></ds-textfield>
          </div>
          <ds-divider></ds-divider>
          <div class="title">
            <typography variant="mat-body-2" weight="medium">
              {{ appStrings.followUp_leads_contact }}
            </typography>
          </div>
          <div class="content" formGroupName="contact" id="contact">
            <ds-textfield class="quarter-width" [label]="appStrings.contacts_firstName" label_orientation="vertical-label"
              [control]="editLeadForm.controls.contact.controls.firstName" id="firstName"
            ></ds-textfield>
            <ds-textfield class="quarter-width" [label]="appStrings.contacts_lastName" label_orientation="vertical-label"
              [control]="editLeadForm.controls.contact.controls.lastName" id="lastName"
            ></ds-textfield>
            <ds-textfield class="quarter-width" [label]="appStrings.contacts_title" label_orientation="vertical-label"
              [control]="editLeadForm.controls.contact.controls.title" id="title"
            ></ds-textfield>
            <ds-textfield class="quarter-width" [label]="appStrings.contacts_department" label_orientation="vertical-label"
              [control]="editLeadForm.controls.contact.controls.department" id="department"
            ></ds-textfield>
            <ds-textfield class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.contacts_email" label_orientation="vertical-label"
              [control]="editLeadForm.controls.contact.controls.email" id="email"
            ></ds-textfield>
            <ds-textfield [ngClass]="isMobile ? 'fill-width' : 'quarter-width'" [label]="appStrings.contacts_phone" label_orientation="vertical-label"
              [control]="editLeadForm.controls.contact.controls.phone" id="phone"
            ></ds-textfield>
            <ds-textfield class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.contacts_addressLine1" label_orientation="vertical-label"
              [control]="editLeadForm.controls.contact.controls.address1" id="address1"
            ></ds-textfield>
            <ds-textfield class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.contacts_addressLine2" label_orientation="vertical-label"
              [control]="editLeadForm.controls.contact.controls.address2" id="address2"
            ></ds-textfield>
            <ds-select (selectionChange)="handleCountryChange(true)" class="quarter-width" [label]="appStrings.contacts_country" [dropOptions]="countries"
              label_orientation="vertical-label" [control]="editLeadForm.controls.contact.controls.countryId" id="country"
            ></ds-select>
            @if (isSelectContactState && !isHiddenContactState) {
              <ds-select class="quarter-width" [label]="appStrings.contacts_state_province"
                [dropOptions]="contactStates" label_orientation="vertical-label" [control]="editLeadForm.controls.contact.controls.stateId" id="province"
              ></ds-select>
            }
            @if (isRegionCountyContact && !isHiddenContactState) {
              <ds-select (selectionChange)="handleRegionChange(true)" class="quarter-width"
                [label]="appStrings.contacts_region" [dropOptions]="contactRegions" label_orientation="vertical-label"
                [control]="editLeadForm.controls.contact.controls.regionId" id="region"
              ></ds-select>
            }
            @if (isRegionCountyContact && !isHiddenContactState) {
              <ds-select class="quarter-width" [label]="appStrings.contacts_county" [dropOptions]="contactCounties"
                label_orientation="vertical-label" [control]="editLeadForm.controls.contact.controls.countyId" id="county"
              ></ds-select>
            }
            @if (!isSelectContactState && !isHiddenContactState && !isRegionCountyContact) {
              <ds-textfield class="quarter-width"
                [label]="appStrings.contacts_state_province" label_orientation="vertical-label"
                [control]="editLeadForm.controls.contact.controls.province.controls.name" id="province"
              ></ds-textfield>
            }
            <ds-textfield class="quarter-width" [label]="appStrings.followUp_editLead_city" label_orientation="vertical-label"
              [control]="editLeadForm.controls.contact.controls.city" id="city"
            ></ds-textfield>
            <ds-textfield class="quarter-width" [label]="zipLabel" label_orientation="vertical-label"
              [control]="editLeadForm.controls.contact.controls.zipCode" id="zip"
            ></ds-textfield>
          </div>
          <ds-divider></ds-divider>
          <div class="content no-title">
            <div class="display-field" id="createdDate">
              <typography variant="mat-body-2" weight="medium">{{appStrings.followUp_leads_date}}</typography>
              <typography variant="mat-body-2" weight="regular">{{date | date: dateFormat}}</typography>
            </div>
            <div class="display-field" id="lastUpdated">
              <typography variant="mat-body-2" weight="medium">{{appStrings.followUp_leads_lastUpdated}}</typography>
              <typography variant="mat-body-2" weight="regular">{{lastUpdated | dateAgo }}</typography>
            </div>
          </div>
          <ds-divider></ds-divider>
          <div class="content no-title">
            <ds-select [ngClass]="isMobile ? 'fill-width' : 'quarter-width'" (selectionChange)="handleStatusChange()" [label]="appStrings.followUp_leads_status"
              [dropOptions]="statuses" [label_orientation]="'vertical-label'" [control]="editLeadForm.controls.status" id="status"
            ></ds-select>
            @if (isStatusNoteVisible) {
              <ds-multiline class="fill-width" [ngClass]="{'half-width': !isMobile}" [label]="appStrings.followUp_leads_statusNotes" label_orientation="vertical-label"
                [control]="editLeadForm.controls.statusNote" id="statusNote"
              ></ds-multiline>
            }
          </div>
          <div class="title">
            <typography variant="mat-body-2" weight="medium">
              {{ appStrings.contacts_notes }}
            </typography>
          </div>
          <div class="content">
            <app-lead-notes [notes]="notes" [accountId]="accountId" class="lead-notes"></app-lead-notes>
          </div>
        </div>
      </form>
    </div>
  }
</div>
<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    @for (button of buttons; track button; let i = $index) {
      <ds-button id="dialogButton_{{i}}" variant="label-only" size="medium"
        [type]="button.type" (onClick)="btnCallback(i)" [label]="button.label">
      </ds-button>
    }
  </div>
</div>
